<template>
  <div class="grid">
    <el-table
      ref="table"
      v-loading="loading"
      :data="list"
      style="width: 100%"
      :row-key="rowKey"
      @selection-change="onSelectionChange"
      @sort-change="onSortChange"
      :row-class-name="rowClassName"
    >
      <el-table-column
        v-if="selectType == 'multi'"
        type="selection"
        width="55"
        :reserve-selection="keepSelected"
      ></el-table-column>
      <el-table-column v-if="selectType == 'single'" width="55" align="center">
        <template slot-scope="{ row }">
          <el-radio v-model="singleValue" :label="row[rowKey]" @change="onSingleChange">
            <span></span>
          </el-radio>
        </template>
      </el-table-column>
      <template v-for="(item, index) in innerColumns">
        <el-table-column
          v-if="!item.disabled"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          :min-width="item.minWidth"
          :align="item.align"
          :type="item.type"
          :sortable="item.sortable"
          :fixed="item.fixed"
          :render-header="item.renderHeader"
          :show-overflow-tooltip="item.showOverflowTooltip"
        >
          <template slot-scope="{ row }">
            <slot v-if="item.slot" :name="item.slot" :row="row"></slot>
            <div v-else>{{ row[item.prop] }}</div>
          </template>
        </el-table-column>
      </template>
      <template slot="empty">
        <slot name="empty"></slot>
      </template>
    </el-table>
    <div class="footer">
      <div class="f-left">
        <slot name="footer-left"></slot>
      </div>
      <el-pagination
        background
        @current-change="onCurrentChange"
        :current-page="page"
        :page-size="limit"
        layout="total, prev, pager, next"
        :total="total"
        v-if="pageCount > 1"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import * as enums from '@/utils/enums';
export default {
  name: 'grid',
  props: {
    columns: {
      type: Array,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    method: {
      type: String,
      default: 'get',
    },
    search: {
      type: Object,
      required: true,
    },
    selectType: {
      type: String,
      default: '',
    },
    // 可选择时候的主键
    rowKey: {
      type: String,
      default: 'id',
    },
    formatter: {
      type: Function,
    },
    getData: {
      type: Function,
    },
    limit: {
      type: Number,
      default: 10,
    },
    // 是否保持选择
    keepSelected: {
      type: Boolean,
      default: false,
    },
    // 是否展示全局loading
    showLoading: {
      type: Boolean,
      default: true,
    },
    rowClassName: {},
    // 是否自动拉取数据
    autoLoadData: {
      type: Boolean,
      default: true,
    },
    // server-请求接口模式   client-本地模式
    mode: {
      type: String,
      default: 'server',
    },
    // 本地数据
    localData: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      page: 1,
      total: 0,
      list: [],
      loading: false,
      singleValue: 0,
      selection: [],
      enums,
    };
  },
  computed: {
    pageCount() {
      if (this.total == 0 || this.limit == 0) return 0;
      return parseInt(this.total / this.limit) + 1;
    },
    innerColumns() {
      const ret = [];
      this.columns &&
        this.columns.forEach((i) => {
          if (i.disabled) return;
          ret.push(i);
        });
      return ret;
    },
    enumColumns() {
      return this.innerColumns.filter((c) => c.enum);
    },
    formatColumns() {
      return this.innerColumns.filter((c) => c.formatter);
    },
  },
  watch: {
    innerColumns: {
      immediate: true,
      handler() {
        this.enumColumns.forEach((c) => {
          if (c.origin_prop) return;
          c.origin_prop = c.prop;
          c.prop = c.prop + '_enum';
        });
        this.formatColumns.forEach((c) => {
          if (c.origin_prop) return;
          c.origin_prop = c.prop;
          c.prop = c.prop + '_format';
        });
      },
    },
    localData() {
      if (this.mode == 'client') {
        this.requestList(true);
      }
    },
  },
  async created() {
    if (this.autoLoadData) {
      await this.requestList(true);
    }
  },
  methods: {
    // on event
    async onCurrentChange(page) {
      this.page = page;
      await this.requestList(false);
    },
    onSelectionChange(val) {
      this.$emit('selection-change', val);
    },
    onSingleChange(val) {
      // val 为单选设定的key，由key来寻找行数据
      const result = this.list.filter((i) => {
        return i[this.rowKey] == val;
      });
      this.$emit('selection-change', result);
    },
    // other
    async searchRefresh() {
      await this.requestList(true);
    },
    async refresh() {
      await this.requestList(false);
    },
    clearSelection() {
      this.singleValue = 0;
      this.$refs.table.clearSelection();
    },
    // format
    formatEnumRows(list) {
      this.enumColumns.forEach((c) => {
        list.forEach((item) => {
          const enumItem = this.enums[c.enum];
          let value = '-';
          if (enumItem) {
            value = enumItem.getValue(item[c.origin_prop]) || '-';
          }
          this.$set(item, c.prop, value);
        });
      });
    },
    formatCell(column, row, origin_prop) {
      const tag = column.formatter,
        origin = row[origin_prop];
      let value;
      switch (tag) {
        case 'datetime':
          value = origin ? this.$pub.ts(origin) : '-';
          break;
        case 'date':
          value = origin ? this.$pub.ts(origin, 'date') : '-';
          break;
        case 'price':
          value = this.$pub.calcPrice(origin);
          break;
        case 'empty':
          value = origin || '-';
          break;
      }
      row[origin_prop + '_format'] = value;
    },
    formatCellRows(list) {
      this.formatColumns.forEach((c) => {
        list.forEach((item) => {
          this.formatCell(c, item, c.origin_prop);
        });
      });
    },
    // request
    async requestList(refresh = true) {
      let data, realData;
      if (this.mode == 'server') {
        if (!this.url) {
          return;
        }
        if (refresh) {
          this.page = 1;
        }
        const params = {
          page: this.page,
          limit: this.limit,
          ...this.search,
        };
        data = await this.$http[this.method](this.url, params, {
          showLoading: this.showLoading,
        });
        if (data.list) {
          realData = data.list;
          this.total = data.total;
        } else {
          realData = data;
        }
      } else {
        data = this.localData;
        this.total = this.localData.length;
        realData = this.localData;
      }
      this.formatEnumRows(realData);
      this.formatCellRows(realData);
      this.formatter && this.formatter(realData);
      this.getData && this.getData(data);
      this.list = realData;
      if (this.list.length == 0 && !refresh && this.page > 1) {
        this.page--;
        this.requestList(refresh);
      }
    },
    onSortChange({ prop, order }) {
      this.$emit('sort', { prop, order });
    },
  },
};
</script>

<style lang="scss" scoped>
.grid {
  ::v-deep .el-table {
    thead th {
      background-color: #f6f6f6 !important;
      border-bottom: none;
    }
    .cell {
      padding: 0 15px;
    }
  }
  .footer {
    overflow: hidden;
    margin-top: 20px;
    position: relative;
    .pos-left {
      position: absolute;
      left: 0;
    }
    .el-pagination {
      margin: 0;
    }
    &::after {
      content: '';
      display: block;
      clear: both;
    }
  }
}
</style>
